import { useEffect, useState, useRef, useCallback } from 'react';
import { criaCookieToken, refreshAccessToken } from '../../../../services/authentication/auth';
import { origemConfiavel } from '../../../../config/origensConfiaveis';

const IframeComponentHook = ({ src }) => {
  const iframeRef = useRef(null);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const isRefreshingRef = useRef(false);
  const srcRef = useRef(src);
  useEffect(() => {
    srcRef.current = src;
  }, [src]);

  useEffect(() => {
    if (src !== '') {
      setSkeletonLoader(true);
    }
  }, [src]);

  const recarregarIframe = useCallback(() => {
    if (!criaCookieToken()) {
      window.location.replace('/force-logout');
      return;
    }
    setSkeletonLoader(true);
    setIframeKey(prev => prev + 1);
  }, []);

  const renovarToken = useCallback(async () => {
    if (isRefreshingRef.current) return;

    try {
      isRefreshingRef.current = true;

      const newAccessToken = await refreshAccessToken();
      if (newAccessToken && srcRef.current) {
        recarregarIframe();
      }
    } catch (err) {
      console.error('Erro ao renovar o token', err);
    } finally {
      isRefreshingRef.current = false;
    }
  }, [recarregarIframe]);

  const handleMessage = useCallback(
    event => {
      const type = event?.data?.type;
      if (!origemConfiavel(event.origin)) return;
      if (!type) return;

      switch (type) {
        case 'iframe-resize':
          setSkeletonLoader(false);
          break;

        case 'token-expirado':
          renovarToken();
          break;

        case 'token-invalido':
          window.location.replace('/force-logout');
          break;

        default:
          break;
      }
    },
    [renovarToken]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  return {
    skeletonLoader,
    iframeRef,
    iframeKey
  };
};

export default IframeComponentHook;
